import { useId, FC, ReactNode, useEffect, ChangeEvent } from 'react';
import { Input } from '@mantine/core';
import classNames from 'classnames';

import './styles.scss';

interface Props {
  label?: string;
  placeholder: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  size?: 'lg' | 'md' | 'sm' | 'xl' | 'xs';
  withAsterisk?: boolean;
  className?: string;
  icon?: JSX.Element;
  disabled?: boolean;
  error?: ReactNode;
  mt?: string;
  type?: 'text' | 'button' | 'password' | "number" | "email";
  required?: boolean;
  ariaLabel?: string;
  value?: string;
  autoFocus?: boolean;
  autoComplete? : string;
  name?: string;
  onKeyDown?: (e:any)=>void;
}

const TextInput: FC<Props> = ({
  label,
  onChange,
  placeholder,
  size,
  withAsterisk,
  className,
  icon,
  onFocus,
  onBlur,
  disabled,
  error,
  type = 'text',
  required,
  ariaLabel,
  value,
  autoFocus = false,
  autoComplete = "",
  name = "",
  onKeyDown
}: Props): JSX.Element => {
  const id = useId();

  useEffect(() => {
    const element = document.getElementById(id);
    if (element !== null) element.setAttribute('aria-invalid', `${Boolean(error)}`);
  }, [error]);

  return (
    <Input.Wrapper
      id={id}
      label={label}
      withAsterisk={withAsterisk}
      // error={error}
      aria-describedby={error?.toLocaleString()}
      className={classNames('text_field_input', {
        ['error']: error,
      })}>
      <Input
        required={required}
        type={type}
        id={id}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        size={size}
        className={classNames(className)}
        onFocus={onFocus}
        onBlur={onBlur}
        rightSection={icon}
        disabled={disabled}
        // error={error}
        aria-label={ariaLabel}
        value={value}
        autoFocus={autoFocus}
        autoComplete={autoComplete}
        onKeyDown={onKeyDown}
      />
       {error && (
        <Input.Error id={error?.toLocaleString()} role="alert" aria-live="assertive">
          {error}
        </Input.Error>
      )}
    </Input.Wrapper>
  );
};

export default TextInput;
